// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout/Layout";
import { useAuth } from "./contexts/loginContext";
import { ROLES_BOLETAS, ROLES_OPERATIVOS, homePathForRole } from "./contexts/roles";
import ProtectedRoute from "./components/Layout/ProtectedRoute";
import SessionGuard from "./components/SessionGuard";

import Dashboard from "./Pages/Dashboard.jsx";
import AsistenciaCampo from "./Pages/AsistenciaCampo.jsx";
import AsistenciaLocal from "./Pages/AsistenciaLocal.jsx";
import AgregarUsuario from "./Pages/AgregarUsuario.jsx";
import InstitutionNotices from "./Pages/InstitutionNotices.jsx";
import LocationMaintenance from "./Pages/LocationMaintenance.jsx";
import BoletasFirmadas from "./Pages/BoletasFirmadas.jsx";
import Login from "./Pages/Login.jsx";

function RoleHome() {
  const { role } = useAuth();
  return <Navigate to={homePathForRole(role)} replace />;
}

export default function App() {
  return (
    <SessionGuard>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<RoleHome />} />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute allowedRoles={ROLES_OPERATIVOS}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="asistencia-campo"
            element={
              <ProtectedRoute allowedRoles={ROLES_OPERATIVOS}>
                <AsistenciaCampo />
              </ProtectedRoute>
            }
          />

          <Route
            path="asistencia-local"
            element={
              <ProtectedRoute allowedRoles={["admin"]} redirectTo="/dashboard">
                <AsistenciaLocal />
              </ProtectedRoute>
            }
          />

          <Route
            path="agregar-usuario"
            element={
              <ProtectedRoute allowedRoles={["admin"]} redirectTo="/dashboard">
                <AgregarUsuario />
              </ProtectedRoute>
            }
          />

          <Route
            path="institution-notices"
            element={
              <ProtectedRoute allowedRoles={["admin"]} redirectTo="/dashboard">
                <InstitutionNotices />
              </ProtectedRoute>
            }
          />

          <Route
            path="location-maintenance"
            element={
              <ProtectedRoute allowedRoles={["admin"]} redirectTo="/dashboard">
                <LocationMaintenance />
              </ProtectedRoute>
            }
          />

          <Route
            path="boletas-firmadas"
            element={
              <ProtectedRoute allowedRoles={ROLES_BOLETAS}>
                <BoletasFirmadas />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </SessionGuard>
  );
}
